// src/components/CookieBanner.jsx
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  // skontroluje, či užívateľ súhlasil
  useEffect(() => {
    if (!localStorage.getItem("cookieConsent")) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "tween", duration: 0.4 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50
                     bg-cream text-navy shadow-lg rounded-2xl p-4 flex flex-col md:flex-row gap-4"
        >
          <img src="cookies.svg" alt="Cookie Icon" width={30} />
          <p className="text-sm flex-1">
            Na spríjemnenie prehliadania používame súbory&nbsp;cookies.  &nbsp;
            <a
              href="/gdpr"         /* alebo link na tvoju stránku o ochrane osobných údajov */
              className="underline underline-offset-4 hover:text-primary"
            >
              Viac informácií
            </a>
          </p>

          <button
            onClick={handleAccept}
            className="self-end md:self-auto bg-primary hover:bg-primary/90
                       text-cream font-semibold px-4 py-2 rounded-xl"
          >
            Súhlasím
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
